import React, { useState, useEffect } from "react";
import Popup from "./popup/Popup";
import { Route } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import { blue } from "@material-ui/core/colors";
import Hidden from "./hidden/Hidden";
import Main from "./Main";
import OrgContext from "./context/OrgContext";

import "./App.css";
import SearchPageWrapper from "./SearchPageWrapper";

const theme = createTheme({
  palette: {
    primary: blue,
  },
});

// TODO : background image; solid color for welcome logo
// TODO : timeout to bring back welcome page
// TODO : confirm that auto scroll reverses  (not calling function when reached bottom)
export default function Squares(props) {
  const appId = props.match.params.appId
  const { api } = props

  const [app, setApp] = useState({})

  const [popUpInfo, setPopupInfo] = useState({
    story: { title: `` },
    open: false,
  })
  const [appHidden, setAppHidden] = useState(false);
  const [searchValue, setSearchValue] = useState(``);
  const [mapStyle, setMapStyle] = useState([]);

  const isMobile = useMediaQuery("(max-width: 900px)");

  useEffect(() => {
    async function getAppInfo(id) {
      const app = await api.exhibit().getShallowById(id)

      if (app.status === `HIDDEN`) {
        setAppHidden(true)
      } else {
        setApp(app)
        document.title = app.name
      }

      const style = await api.mapStyle().getByName(app.mapStyle)
      setMapStyle(style)
    }

    getAppInfo(appId)

  }, [appId])

  let openPopup = (s) => {
    setPopupInfo({
      story: { ...s },
      open: true,
    });
  };

  let handleViewClicked = (story) => () => {
    openPopup(story);
  };

  let closePopup = () => {
    setPopupInfo({
      open: false,
      story: { title: `` },
    });
  };

  let handleTagClicked = (tag) => {
    closePopup();
    setSearchValue(`#${tag.value}`);
    props.history.push(`${props.match.url}/search/${tag.value}`);
  }

  const handleShowStory = async (storyId) => {
      const story = await api.story.getById(storyId)
    if (story) {
      openPopup(story)
    }
  }

  return (
    <>
      {appHidden && <Hidden />}
      {!appHidden && (
        <MuiThemeProvider
          theme={
            app.mainColor
              ? createTheme({
                  palette: {
                    primary: { main: app.mainColor },
                    secondary: { main: app.secondaryColor },
                  },
                  breakpoints: {
                    values: {
                      xs: 1,
                      md: 860,
                      lg: 961,
                      xl: 1025,
                    },
                  },
                })
              : theme
          }
        >
          <OrgContext.Provider
            value={{
              orgId: app.orgId,
            }}
          >
            <div>
              <Route
                exact
                path={props.match.url}
                render={(props) => (
                  <Main
                    {...props}
                    api={api}
                    app={app}
                    isMobile={isMobile}
                    viewClicked={handleViewClicked}
                  />
                )}
              />

              <Route
                exact
                path={`${props.match.url}/search/:searchValue`}
                render={(props) => (
                  <SearchPageWrapper
                    {...props}
                    api={api}
                    appId={appId}
                    searchValue={searchValue}
                    showStory={handleShowStory}
                  />
                )}
              />

              <Popup
                settings={popUpInfo}
                api={api}
                app={app}
                tagClick={handleTagClicked}
                mapStyle={mapStyle}
                isMobile={isMobile}
                close={() =>
                  setPopupInfo({
                    story: { title: `` },
                    open: false,
                  })
                }
              />
            </div>
          </OrgContext.Provider>
        </MuiThemeProvider>
      )}
    </>
  );
}
